export const SET_EDIT_FORM_MODAL = 'SET_EDIT_FORM_MODAL';

export const setEditFormModal = ({ showModal, formId }) => {
  return { type: SET_EDIT_FORM_MODAL, payload: { showModal, formId } };
};
